<!-- 报纸设置弹窗 -->
<template>
  <div class="paper-set-dialog">
    <el-dialog class="common-dialog" title="报纸设置" :visible.sync="visible" center :modal-append-to-body="false" :close-on-click-modal="false" width="600px">
      <el-form label-width="80px" :model="formDetail" class="paperSetForm">
        <el-form-item label="报纸名称">
          <el-input v-model="formDetail.name" size="mini" class="paperNameInput"></el-input>
        </el-form-item>
        <el-form-item label-width="112px" label="PC端报纸样式">
          <el-select size="mini" v-model="formDetail.style" placeholder="请选择">
            <el-option label="传统布局" :value="1"> </el-option>
            <el-option label="仿真翻页" :value="0"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="122px" label="移动端翻页方式">
          <el-select size="mini" v-model="formDetail.mobilePageMethod" placeholder="请选择">
            <el-option label="平移翻页" :value="1"> </el-option>
            <el-option label="仿真翻页" :value="0"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="翻页方向" v-show="formDetail.mobilePageMethod === 1">
          <el-select size="mini" v-model="formDetail.pageDirection" placeholder="请选择">
            <el-option label="上下翻页" :value="1"> </el-option>
            <el-option label="左右翻页" :value="0"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发布方式">
          <div>
            <el-select size="mini" v-model="formDetail.publishMethod" placeholder="请选择">
              <el-option label="直接发布" :value="0"> </el-option>
              <el-option label="手动发布" :value="1"> </el-option>
              <el-option label="定时发布" :value="2"> </el-option>
            </el-select>
            <span v-show="formDetail.publishMethod === 2">
              <el-select size="mini" v-model="hour" placeholder="时" class="hourSelector">
                <el-option v-for="item in 24" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              时
              <el-select size="mini" v-model="minute" placeholder="分" class="minuteSelector">
                <!-- <el-option v-for="item in 60" :key="item" :label="item" :value="item"></el-option> -->
                <el-option :label="0" :value="0"></el-option>
                <el-option :label="30" :value="30"></el-option>
              </el-select>
              分
            </span>
          </div>
          <el-checkbox v-model="formDetail.audit" v-show="formDetail.publishMethod !== 0">发布需要审核</el-checkbox>
        </el-form-item>
        <el-form-item label="账号权限" v-if="formDetail.publishMethod !== 0">
          <div>
            <el-form-item label="查看未发布作品" label-width="8em">
              <el-select size="mini" v-model="formDetail.viewPrivilege" placeholder="请选择">
                <el-option label="仅自己可见" :value="0"> </el-option>
                <el-option label="所有团队账号可见" :value="1"> </el-option>
                <el-option label="指定账号可见" :value="2"> </el-option>
              </el-select>
              <el-button type="text" class="viewPrivilegeSetBtn" @click="accountDialogVisible = true" v-show="formDetail.viewPrivilege === 2">设置</el-button>
            </el-form-item>
            <el-dialog title="可查看未发布作品账号" :visible.sync="accountDialogVisible" center append-to-body :close-on-click-modal="false" width="400px">
              <el-table :data="accountSetTableData" style="width: 100%">
                <el-table-column prop="account" label="账号"></el-table-column>
                <el-table-column prop="name" label="是否可查看">
                  <template slot-scope="{ row }">
                    <el-radio-group v-model="row.view" :disabled="row.account === userName">
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                  </template>
                </el-table-column>
              </el-table>
              <span slot="footer" class="dialog-footer">
                <el-button type="info" @click="accountDialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="accountSetConfirm" size="small">确 定</el-button>
              </span>
            </el-dialog>
          </div>
          <div v-show="formDetail.audit">
            <el-form-item label="作品审核人" label-width="8em">
              <el-select size="mini" v-model="formDetail.auditAccount" placeholder="请选择">
                <el-option v-for="item in accountSetTableData" :key="item.account" :label="item.account" :value="item.account"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item label="展示范围">
          <el-select size="mini" v-model="formDetail.showRange" placeholder="请选择">
            <el-option label="全部展示" :value="0"> </el-option>
            <el-option label="指定期数" :value="1"> </el-option>
            <el-option label="指定时间" :value="2"> </el-option>
          </el-select>
          <div class="period" v-if="formDetail.showRange === 1"><el-input type="number" size="mini" v-model="formDetail.showPeriod" @input="handlePeriodInput"></el-input>期</div>
          <div class="date" v-if="formDetail.showRange === 2">
            <el-date-picker size="mini" v-model="formDetail.showDate" value-format="yyyy-MM-dd" format="yyyy 年 MM 月 dd 日" type="date" placeholder="选择日期" class="datePicker"> </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label-width="135px" label="是否展示到阅新闻">
          <el-select size="mini" v-model="formDetail.yueNews" placeholder="请选择">
            <el-option label="展示" :value="1"> </el-option>
            <el-option label="不展示" :value="0"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="visible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="clickConfirm" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <tip-dialog ref="tipDialog" :showClose="false" :dialogOptions="dialogOptions" @clickCancel="dialogCancel" @clickConfirm="dialogConfirm"></tip-dialog>
  </div>
</template>

<script>
import apis from '@api/getBook'
import subAccount from '@api/subAccount'
import TipDialog from '@components/common/TipDialog'

export default {
  name: 'PaperSetDialog',
  components: { TipDialog },
  data() {
    return {
      visible: false,
      formDetail: {},
      originMethod: 0,
      showRanges: [],
      accountDialogVisible: false,
      accountSetTableData: [],
      hour: 1,
      minute: 0,
      loading: null,
      dialogOptions: {
        // 弹框类型
        type: 'choose',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '是否发布全部未发布作品？',
        confirmText: '是',
        cancelText: '否'
      }
    }
  },
  methods: {
    handlePeriodInput() {
      this.formDetail.showPeriod = this.formDetail.showPeriod.replace(/\D/g, '')
      if (Number(this.formDetail.showPeriod) > 2000) {
        this.formDetail.showPeriod = 2000
      }
    },
    init(id) {
      this.loading = this.$loading({
        lock: true,
        text: '数据加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      this.getDetail(id)
    },
    getDetail(id) {
      apis.getBaoZhiById({ id }).then((res) => {
        this.loading.close()
        this.visible = true
        console.log(res)
        this.formDetail = res.data.data
        if (this.formDetail.publishTime) {
          let publishTimeArr = this.formDetail.publishTime.split(':')
          this.minute = publishTimeArr[1]
          this.hour = publishTimeArr[0]
        }
        this.formDetail.audit = Boolean(this.formDetail.audit)
        if (this.formDetail.showDate) {
          this.formDetail.showDate = new Date(res.data.data.showDate)
        }
        this.originMethod = this.formDetail.publishMethod
        this.getMainChildAccountList()
      })
    },
    clickConfirm() {
      let param = {
        ...this.formDetail
      }
      if (param.publishMethod === 2) {
        //publishTime的换算方法：(小时*60*60+分钟*60+秒)*1000 - 28,800,000
        param.publishTime = (this.hour * 60 * 60 + this.minute * 60) * 1000 - 28800000
      } else {
        delete param.publishTime
      }
      // 处理选择“制定账号可见”，却并未指定可见账号的情况
      if (param.viewPrivilege === 2) {
        param.viewAccount = this.accountSetTableData
          .filter((item) => item.view)
          .map((item) => item.account)
          .join(',')
      }
      // audit booler转数字
      param.audit = Number(param.audit)
      this.formDetail = param
      if (this.originMethod !== 0 && param.publishMethod === 0) {
        this.$refs.tipDialog.visible = true
      } else {
        this.editSubMit(param)
      }
    },
    dialogConfirm() {
      this.editSubMit(this.formDetail)
    },
    dialogCancel() {
      this.formDetail.publishMethod = 3
      this.editSubMit(this.formDetail)
    },
    editSubMit(param) {
      apis
        .editBaoZhiSetting(param)
        .then((res) => {
          let { status } = res.data
          if (status == 0) {
            this.$parent.getManagerList()
          }
        })
        .finally(() => {
          this.clickCancel()
        })
    },
    clickCancel() {
      this.visible = false
    },
    formCheck() {
      let msg = ''
      if (this.formDetail.name.length === 0) {
        msg = '报纸名称不能为空'
      } else if (this.formDetail.publishMethod === 0) {
      }
    },
    open(item) {
      this.paperData = item
      this.selectedStyle = item.style || 0
      this.visible = true
    },
    accountSetConfirm() {
      this.accountDialogVisible = false
    },
    getMainChildAccountList() {
      let checkedList = this.formDetail.viewAccount ? this.formDetail.viewAccount.split(',') : []
      subAccount
        .getMainChildAccountList({
          userName: localStorage.getItem('username')
        })
        .then((res) => {
          this.accountSetTableData = res.data.data.map((item) => {
            return {
              account: item,
              view: this.userName == item || checkedList.includes(item)
            }
          })
        })
    }
  },
  computed: {
    userName() {
      return localStorage.getItem('username')
    }
  }
}
</script>

<style scoped lang="scss">
.paper-set-dialog {
  &__title {
    margin-right: 10px;
  }
  .paperSetForm {
    text-align: left;
    .paperNameInput {
      width: 193px;
    }
    .viewPrivilegeSetBtn {
      color: #df5813;
      margin-left: 10px;
    }
    .period,
    .date {
      display: inline-block;
      margin-left: 30px;
    }
    .datePicker {
      width: 200px;
    }
    .period .el-input {
      width: 100px;
      margin-right: 10px;
    }
    .hourSelector,
    .minuteSelector {
      width: 100px;
      margin-left: 10px;
    }
  }
}
</style>
